<script setup lang="ts">
defineProps({
  description: {
    required: true,
    type: String,
  },
  path: {
    required: true,
    type: String,
  },
  title: {
    required: true,
    type: String,
  },
})

const { t } = useI18n()
const localePath = useLocalePath()
</script>

<template>
  <UCard
    class="not-prose group relative cursor-pointer overflow-hidden"
    :ui="{ base: '!p-0', body: { padding: '!p-8' } }"
    @click="navigateTo(localePath(path))"
  >
    <BaseMask
      class="absolute inset-0 z-0 opacity-60 dark:opacity-100"
      image="search"
    />

    <div class="z-10 flex size-full items-center justify-center gap-2 md:flex-row md:justify-normal">
      <div class="relative flex w-full flex-1 flex-col">
        <h3 class="text-lg font-semibold leading-tight">
          {{ title }}
        </h3>

        <p class="text-sm text-gray-600 dark:text-gray-400">
          {{ description }}
        </p>
      </div>

      <div class="flex w-fit items-center">
        <UButton
          class="group-hover:scale-102 z-50 group-hover:!text-gray-900 group-hover:underline dark:group-hover:!text-white"
          :trailing-icon="getIcon('arrowPointingRight')"
          variant="link"
        >
          <span class="hidden md:block">
            {{ t('button.readMore') }}
          </span>
        </UButton>
      </div>
    </div>
  </UCard>
</template>

<i18n lang="json">
{
  "en": {
    "button": {
      "readMore": "Read the documentation"
    }
  },
  "es": {
    "button": {
      "readMore": "Leer la documentación"
    }
  },
  "fr": {
    "button": {
      "readMore": "Lire la documentation"
    }
  }
}
</i18n>
